import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {sleep} from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-show-social-links',
	templateUrl: './show-social-links.component.html',
	styleUrls: ['./show-social-links.component.scss']
})
export class ShowSocialLinksComponent implements OnInit {
	userCoordinates: {lng: number; lat: number};
	socialMedia = [
		{name: 'Telegram', url: 'https://t.me/share/url?url=http://maps.google.com/maps?q=loc:'},
		{name: 'Viber', url: 'https://viber://forward?text=http://maps.google.com/maps?q=loc:'},
		{name: 'WhatsApp', url: 'https://whatsapp://send?text=http://maps.google.com/maps?q=loc:'}
	];
	constructor(private modalCtrl: ModalController) {}

	ngOnInit() {}
	static async show(modal: ModalController, userCoordinates: {lng: number; lat: number}): Promise<any> {
		const resultScan = await modal.create({
			component: ShowSocialLinksComponent,
			cssClass: 'favourite-modal-on-add auto-height',
			componentProps: {
				userCoordinates: userCoordinates
			}
		});
		await resultScan.present();
		const result = await resultScan.onDidDismiss();
		await sleep(100);
		return result.data;
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
	generateLink(url: string) {
		return url + this.userCoordinates.lat + ',' + this.userCoordinates.lng;
	}
}
